"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _defineProperty = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/opt/build/repo/docs/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/asyncToGenerator");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useToken;

var _react = require("react");

var _querystring = _interopRequireDefault(require("querystring"));

var _useSetState = _interopRequireDefault(require("react-use/lib/useSetState"));

var _useInterval = _interopRequireDefault(require("@arcblock/react-hooks/lib/useInterval"));

var _eventClient = _interopRequireDefault(require("@arcblock/event-client"));

var _locale = _interopRequireDefault(require("../assets/locale"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable no-underscore-dangle */


var fns = {};

function createTokenFn(action, prefix, checkFn, extraParams) {
  var key = "".concat(prefix, "/").concat(action, "/token?").concat(_querystring["default"].stringify(extraParams || {}));

  if (!fns[key]) {
    fns[key] = /*#__PURE__*/function () {
      var _createToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return checkFn(key);

              case 2:
                res = _context.sent;

                if (!(res.data && res.data.token)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", res.data);

              case 5:
                throw new Error("Error generating ".concat(action, " qrcode"));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function createToken() {
        return _createToken.apply(this, arguments);
      }

      return createToken;
    }();
  }

  return fns[key];
}

function useToken(_ref) {
  var action = _ref.action,
      checkFn = _ref.checkFn,
      checkInterval = _ref.checkInterval,
      checkTimeout = _ref.checkTimeout,
      extraParams = _ref.extraParams,
      locale = _ref.locale,
      prefix = _ref.prefix,
      socketUrl = _ref.socketUrl,
      tokenKey = _ref.tokenKey,
      onClose = _ref.onClose,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess;
  var maxCheckCount = Math.ceil(checkTimeout / checkInterval);
  var createToken = createTokenFn(action, prefix, checkFn, extraParams);
  var subscriptions = (0, _react.useRef)({});
  var socket = (0, _react.useRef)(null);

  var _ref2 = (0, _react.useState)(null),
      _ref3 = _slicedToArray(_ref2, 2),
      connection = _ref3[0],
      setConnection = _ref3[1];

  var _ref4 = (0, _react.useState)(null),
      _ref5 = _slicedToArray(_ref4, 2),
      subscription = _ref5[0],
      setSubscription = _ref5[1];

  var _ref6 = (0, _react.useState)(false),
      _ref7 = _slicedToArray(_ref6, 2),
      onSuccessCalled = _ref7[0],
      setOnSuccessCalled = _ref7[1];

  var _ref8 = (0, _useSetState["default"])({
    checking: false,
    loading: false,
    token: '',
    url: '',
    store: null,
    status: 'created',
    error: null,
    checkCount: 0
  }),
      _ref9 = _slicedToArray(_ref8, 2),
      state = _ref9[0],
      setState = _ref9[1];

  var params = Object.assign({}, extraParams, _defineProperty({}, tokenKey, state.token));

  var getCheckInterval = function getCheckInterval() {
    if (!state.token) {
      return null;
    }

    if (state.loading) {
      return null;
    }

    if (['succeed', 'error', 'timeout'].includes(state.status)) {
      return null;
    }

    return checkInterval;
  };

  var unsubscribe = function unsubscribe() {
    try {
      checkFn("".concat(prefix, "/").concat(action, "/timeout?").concat(_querystring["default"].stringify(params)));
    } catch (err) {// Do nothing
    }

    try {
      if (state.token && connection && subscription) {
        connection.unsubscribe('auth', state.token);
      }
    } catch (err) {// Do nothing
    }
  }; // 切换账户或者 token 过期之后需要重新生成


  var generate = /*#__PURE__*/function () {
    var _generate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var cleanup,
          data,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cleanup = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;

              if (cleanup) {
                unsubscribe();
              }

              _context2.prev = 2;
              // eslint-disable-next-line object-curly-newline
              setState({
                loading: true,
                token: '',
                url: '',
                store: null
              });
              _context2.next = 6;
              return createToken();

            case 6:
              data = _context2.sent;
              setState({
                loading: false,
                token: data.token,
                url: data.url,
                status: 'created',
                error: '',
                checkCount: 0
              });
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](2);
              setState({
                loading: false,
                status: 'error',
                error: _locale["default"][locale].generateError
              });

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 10]]);
    }));

    function generate() {
      return _generate.apply(this, arguments);
    }

    return generate;
  }(); // 关闭时如果 token 状态处于 created，那么应该通知后端给删掉


  var cancel = function cancel() {
    if (state.status === 'created') {
      checkFn("".concat(prefix, "/").concat(action, "/timeout?").concat(_querystring["default"].stringify(params)));
    }

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  (0, _react.useEffect)(function () {
    // Create our first token if we do not have one
    if (!state.token && !state.store && !state.loading && !state.error) {
      generate(false);
      return;
    } // Try to use websocket


    if (state.token && socketUrl && !socket.current) {
      socket.current = new _eventClient["default"](socketUrl);
      setConnection(socket.current);
      return;
    }

    if (state.token && connection && !subscriptions.current[state.token]) {
      connection.subscribe('auth', state.token).then(function (sub) {
        setSubscription(sub);
        subscriptions.current[state.token] = sub;
        sub.on('data', function (data) {
          var status = data.status,
              error = data.error;

          if (status === 'forbidden') {
            error = _locale["default"][locale].forbidden;
            status = 'error';
          }

          setState({
            status: status,
            store: data,
            error: error
          });
        });
      })["catch"](function () {// Do nothing
      });
    } // Mark token as expired if exceed max retry count


    if (state.status !== 'timeout' && state.checkCount > maxCheckCount) {
      setState({
        status: 'timeout'
      });
      unsubscribe();
      return;
    } // Trigger on success if we completed the process


    if (state.status === 'succeed') {
      if (typeof onSuccess === 'function' && !onSuccessCalled) {
        setOnSuccessCalled(true);
        onSuccess(state.store);
      }
    }
  }); // Check auth token status

  (0, _useInterval["default"])( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var res, _res$data, status, newError, err, response, _msg, _err;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!state.checking) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            setState(function (prevState) {
              return {
                checkCount: prevState.checkCount + 1
              };
            }); // Do not do status check if we have websocket connection

            if (!(connection && subscription)) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return");

          case 5:
            _context3.prev = 5;
            setState({
              checking: true
            });
            _context3.next = 9;
            return checkFn("".concat(prefix, "/").concat(action, "/status?").concat(_querystring["default"].stringify(params)));

          case 9:
            res = _context3.sent;
            _res$data = res.data, status = _res$data.status, newError = _res$data.error;
            setState({
              store: res.data,
              checking: false,
              status: status
            });

            if (!(status === 'error' && newError)) {
              _context3.next = 16;
              break;
            }

            err = new Error(newError);
            err.response = res;
            throw err;

          case 16:
            _context3.next = 22;
            break;

          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](5);
            response = _context3.t0.response;

            if (response && response.status) {
              checkFn("".concat(prefix, "/").concat(action, "/timeout?").concat(_querystring["default"].stringify(params)));
              _msg = response.data && response.data.error ? response.data.error : _context3.t0.message;
              _err = new Error(_msg);
              _err.code = response.status;
              setState({
                status: 'error',
                checking: false,
                error: _msg
              });
              onError(_err);
            } else {
              setState({
                status: 'error',
                checking: false,
                error: _locale["default"][locale].generateError
              });
            }

          case 22:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[5, 18]]);
  })), getCheckInterval());
  return [state, generate, cancel];
}